<template>
	<div class="tipcon">
		<div class="frame">
			<div>
				<div class="titleimg">
					<span>{{title}}</span>
					<img v-if="imgtype == '1'" src="../static/img/tipimg_o@2x.png" alt=""/>
					<img v-if="imgtype == '2'" src="../static/img/tipimg_t@2x.png" alt=""/>
					<img v-if="imgtype == '3'" src="../static/img/tipimg_g@2x.png" alt=""/>
					<img v-if="imgtype == '4'" src="../static/img/tipimg_p@2x.png" alt=""
					style="height:33px;width: 81px;"/>
					<img v-if="imgtype == '5'" src="../static/img/tipimg_x.png" alt=""/>
				</div>
				<div class="line" :style="'width:'+width*100+'px'"></div>
			</div>
			
			<div class="curname pinter">
				当前位置：
				<span v-for="(item,ind) in name" :key='ind' @click="goPage(item.url)">
					{{item.label}}
					<span v-if='ind!=name.length-1'>></span>
				</span>
			</div>
		</div>
		
		
		
	</div>
	
</template>

<script>

export default {
  props:['title','name','imgtype','width'],
  
  data: function() {
		return {
		  
		  
		};
  },
  
  mounted() {
  	
  },
  
  methods: {
	  goPage(url){
		  if(url){
			  this.$router.push({path:url})
		  }
	  },
  },
  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.tipcon{
	
	.frame{
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #FA9E1E;
		.titleimg{
			margin-bottom: 10px;
			span{
				font-size:38px;
				font-weight: 400;
				color: #FA9E1E;
			}
			img{
				margin-left: 10px;
				width:43px;
				height:38px;
			}
		}
		.line{
			background-color: #E61F26;
			// width: 2.05rem;
			height:12px;
		}
		.curname{
			display: flex;
			align-items: flex-end;
			font-size:16px;
			font-weight: 400;
			color: #333333;
			margin-bottom: 20px;
		}
	}
	
	
	
}

</style>
